import { ArrowLeftIcon, ArrowRightIcon } from '@repo/icons';
import { useBreakpoint, useDirection } from '@repo/react-hooks';
import { Button } from '@repo/ui/button';
import React from 'react';
import { type ViewType } from '@/app/[locale]/(account)/account/withdraw';
import { PAYMENT_TYPES } from '@/constants';
import { type FullMethod } from '@/hooks/usePaymentMethodsWithNetworks';
import { type PaymentTypes } from '@/server-actions/payment-methods';
import CreditCardsHeader from './credit-cards-header';
import DepositCryptoDetailsHeader from './deposit-crypto-details-header';
import FiatHeader from './fiat-header';
import WithdrawCryptoDetailsHeader from './withdraw-crypto-details-header';

type PaymentMethodDetailsHeaderProps = {
  paymentType: PaymentTypes;
  view: ViewType;
  setView: (view: ViewType) => void;
  selectedMethod?: FullMethod;
  setSelectedMethod?: (method?: FullMethod) => void;
  setStep: (step: number) => void;
  isQuickDeposit?: boolean;
};

const PaymentMethodDetailsHeader = ({
  paymentType,
  view,
  setView,
  selectedMethod,
  setSelectedMethod,
  setStep,
  isQuickDeposit,
}: PaymentMethodDetailsHeaderProps) => {
  const { matches: isMobile } = useBreakpoint('sm', 'max');

  const direction = useDirection();

  const backButtonRenderer = isMobile && (!isQuickDeposit || view === 'CRYPTO_DETAILS') && (
    <Button
      variant="grey"
      className="rounded-full !bg-transparent p-0 pr-2 rtl:pl-2"
      onClick={() => {
        setStep(1);
        setView(null);
        setSelectedMethod?.(undefined);
      }}
    >
      {direction === 'rtl' ? <ArrowRightIcon className="size-5" /> : <ArrowLeftIcon className="size-5" />}
    </Button>
  );

  switch (true) {
    case paymentType === PAYMENT_TYPES.DEPOSITS && view === 'CRYPTO_DETAILS':
      return (
        <DepositCryptoDetailsHeader
          selectedMethod={selectedMethod}
          backButtonRenderer={backButtonRenderer}
        />
      );
    case paymentType === PAYMENT_TYPES.WITHDRAWALS && view === 'CRYPTO_DETAILS':
      return (
        <WithdrawCryptoDetailsHeader
          selectedMethod={selectedMethod}
          backButtonRenderer={backButtonRenderer}
        />
      );
    case view === 'FIAT' && !isQuickDeposit:
      return (
        <FiatHeader
          paymentType={paymentType}
          backButtonRenderer={backButtonRenderer}
        />
      );
    case view === 'CREDIT_CARDS' && !isQuickDeposit:
      return (
        <CreditCardsHeader
          paymentType={paymentType}
          backButtonRenderer={backButtonRenderer}
        />
      );
    default:
      return null;
  }
};

export default PaymentMethodDetailsHeader;
